import {Stack} from "expo-router";
import {Authenticated} from "@/components/common/Authenticated";
import {NotificationBadgeSync} from "@/components/common/NotificationBadgeSync";
import {PendingRouteHandler} from "@/components/common/PendingRouteHandler";
import {PushRegistration} from "@/components/common/PushRegistration";
import {SuspenseWithRetryFallback} from "@/components/common/SuspenseWithRetryFallback";

export default function AppLayout() {
    return (
        <Authenticated>
            <PushRegistration/>
            <NotificationBadgeSync/>
            <SuspenseWithRetryFallback>
                <Stack screenOptions={{headerShown: false}}/>
            </SuspenseWithRetryFallback>
            {/* After the navigator, and outside the suspense boundary: it navigates, so the
                <Stack> should have committed first, and a suspended screen must not delay the
                deep link that asked for it. Being inside <Authenticated> is what makes it the
                right place to replay one — it cannot mount until the user is past the gate. */}
            <PendingRouteHandler/>
        </Authenticated>
    );
}
